import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations } from "../lib/i18n";

const LangCtx = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("mazad_lang") || "en");

  useEffect(() => {
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = lang;
    localStorage.setItem("mazad_lang", lang);
  }, [lang]);

  // Memoise so children only re-render when `lang` actually changes.
  const value = useMemo(() => {
    const t = (path) => {
      const parts = path.split(".");
      let node = translations[lang] || translations.en;
      for (const p of parts) {
        if (node && typeof node === "object" && p in node) node = node[p];
        else return path;
      }
      return typeof node === "string" ? node : path;
    };
    const setLang = (l) => setLangState(l);
    const toggle = () => setLangState((l) => (l === "en" ? "ar" : "en"));
    return { lang, setLang, toggle, t };
  }, [lang]);

  return <LangCtx.Provider value={value}>{children}</LangCtx.Provider>;
}

export const useLang = () => useContext(LangCtx);
